import events from 'events.js';
import ko from 'knockout';

import 'ko/bindings/stop_binding.js';
import 'ko/bindings/tooltip.js';

(async function() {
    await events.ready();
    const headerElem = document.querySelector('[data-header="top"]');
    const headerElemPosition = headerElem.offsetTop;
    for (const elem of Array.from(
        document.getElementsByClassName('section-links'),
    )) {
        events.listen(elem, 'click', function() {
            const contentId = elem.id.replace('nav', 'content');
            const contentElem = document.getElementById(contentId);
            for (const e of Array.from(
                document.getElementsByClassName('main-content'),
            )) {
                e.classList.remove('hide');
                e.classList.add('hide');
            }
            contentElem.classList.remove('hide');
            for (const e of Array.from(
                document.getElementsByClassName('section-links'),
            )) {
                e.classList.remove('active');
            }
            elem.classList.add('active');
            if (window.pageYOffset > headerElemPosition) {
                headerElem.scrollIntoView();
            }
        });
    }
    const hash = document.location.hash;
    if (hash) {
        const decoded = decodeURI(hash);
        const hashElem = document.getElementById(
            `${decoded.replace('#', '')}-nav`,
        );
        if (hashElem) {
            events.trigger(hashElem, 'click');
        }
    }

    // for all branded buttons, check contrast and invert text if needed
    for (const elem of Array.from(
        document.getElementsByClassName('btn -branded'),
    )) {
        const colorBackground = elem.style.backgroundColor.match(
            /^rgba?\((\d+),\s*(\d+),\s*(\d+)(?:,\s*(\d+(?:\.\d+)?))?\)$/,
        );
        const colorRed = colorBackground[1];
        const colorGreen = colorBackground[2];
        const colorBlue = colorBackground[3];

        // hsp equation from http://alienryderflex.com/hsp.html
        const hsp = Math.sqrt(
            0.299 * (colorRed * colorRed) +
                0.587 * (colorGreen * colorGreen) +
                0.114 * (colorBlue * colorBlue),
        );

        if (hsp > 255 * 0.75) {
            elem.style.color = '#000';
        } else {
            elem.style.color = '#fff';
        }
    }
    ko.applyBindings(null);
})();
